const cyclicPackages = () => {

    // CYCLIC PACKET REQUEST

    let numberInput = document.getElementById("numberInput");
    let numberSubmit = document.getElementById('numberSubmit');
    
    // Validate input
    if(numberInput) {
        numberInput.addEventListener('input', function (evt) {
            if (/^\d{9}$/.test(numberInput.value)) {
                numberSubmit.removeAttribute('disabled');
            };
        });
    }

    // Process request
    if(numberSubmit) {
        numberSubmit.addEventListener('click', function() {

            let requestUrl = 'https://driver.gjde.pl/rest/message/one-time-payment-link?msisdn=' + numberInput.value;
    
            fetch(requestUrl)
            .then(response => {
                console.log(response);
                if (response.status === 429) {
                    document.getElementById('numberReturn').innerHTML = '<p class="fw-bolder text-center text-danger">429 (Too Many Requests)</p>';
                    throw new Error('429 (Too Many Requests)');
                }
                return response.text()
            })
            .then((data) => {
                console.log(data);
                let obj = data ? JSON.parse(data) : {}
    
                if (typeof obj.message !== 'undefined') {
                    document.getElementById('numberReturn').innerHTML = '<p class="fw-bolder text-center text-warning">' + obj.message + '</p>';
                } else {
                    document.getElementById('numberReturn').innerHTML = '<p class="fw-bolder text-center text-success">Dziękujemy, SMS został wysłany</p>';
                    document.getElementById('numberInput').value = '';
                };
            })
            .catch((error) => {
                return error;
            })
    
        })
    }
        
}

export default cyclicPackages;